export const HOME_REPORTS_DEMO_TOTALS = {
  impressions: 248500,
  clicks: 8420,
  mainAction: 312,
  spend: {
    USD: 12480,
  },
};

export const HOME_REPORTS_DEMO_TOTALS_LAST_PERIOD = {
  impressions: 221000,
  clicks: 6820,
  mainAction: 268,
  spend: {
    USD: 10850,
  },
};

export const getHomeReportsDemoStatistics = () => ({
  totals: HOME_REPORTS_DEMO_TOTALS,
  totalsLastPeriod: HOME_REPORTS_DEMO_TOTALS_LAST_PERIOD,
});
